<template>
    <layout>
        <div class="container pt-6 mx-auto">
            <div class="max-w-4xl mx-auto my-8 ">
                <SearchComponent />     
                <div class="flex flex-wrap justify-center w-full mt-5">
                     <ButtonComponent 
                        v-for="category in $page.props.categories"
                        :key="category.id"
                        :content="category.name" 
                        :icon="null"
                        :link="$page.url == '/category/'+category.id+'/fruits' ? '/' : '/category/'+category.id+'/fruits'"
                        type="1"
                        :active="$page.url == '/category/'+category.id+'/fruits'" 
                        />
                </div>
            </div>
            <hr class="mt-8 border-light_gray"/>
            <h1 class="px-4 mb-10 text-xl font-bold my-9 text-enriqueto_green">{{category.name}} </h1>
            <FruitCollectionPaginated :category="category.id" :list="fruits" />
        </div>
    </layout>    
</template>

<script>
import SearchComponent from '../../Components/Shared/SearchComponent.vue'
import FruitColletion from '../../Components/Fruit/FruitColletion.vue'
import Layout from '../../Components/Shared/Layout.vue'
import ButtonComponent from '../../Components/Shared/ButtonComponent.vue'
import FruitCollectionPaginated from '../../Components/Fruit/FruitCollectionPaginated.vue'
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {Layout,FruitColletion,FruitCollectionPaginated,SearchComponent,Link,ButtonComponent},
    props: ['category','fruits'],
    setup(props){
        console.log(props.fruits);
    }
}
</script>

<style>

</style>
